import { useEffect } from 'react';
import { User } from '../types/user';

export const useSegmentLoginTracking = (userData: User | null): void => {
  useEffect(() => {
    if (userData?.id) {
      const { id, name, email } = userData;

      return window.analytics.identify(id, {
        name,
        email,
      });
    }
    window.analytics.reset();

    // ignoring this, since the change in id is sufficient to know the user has changed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.id]);
};
